export default {
  infoTitle: {
    id: 'service_drawer_faq_title',
    defaultMessage: 'Frequently Asked Questions',
  },
  infoQuestion1: {
    id: 'service_drawer_faq_question1',
    defaultMessage:
      'What is the difference between the refurbisher warranty and our Repair services?',
  },
  infoResponse1: {
    id: 'service_drawer_faq_response1',
    defaultMessage:
      'The refurbisher warranty is included in every purchase on Back Market. This warranty only covers defects and functionality issues. With our repair services, we step in for damages, defects, cosmetic or functionality issues.',
  },
  infoQuestion2: {
    id: 'service_drawer_faq_question2',
    defaultMessage: 'How do I submit a service request?',
  },
  infoResponse2: {
    id: 'service_drawer_faq_response2',
    defaultMessage:
      "You can open a service request on our partner's portal. You'll get an answer within 1 working day. We provide a tailored solution for your situation: maintenance, repair or a virtual card to use on Back Market to replace your device.",
  },
  infoQuestion3: {
    id: 'service_drawer_faq_question3',
    defaultMessage: 'What’s included in repair services?',
  },
  infoResponse3: {
    id: 'service_drawer_faq_response3',
    defaultMessage:
      "People usually don't trust protection plans so we decided to do things a little differently. Our repair services do exactly what they say. Our services aims at expanding the lifespan of your device. Throughout unlimited requests, with no justification needed, we can step in for wear and tear, maintenance, cosmetic or functional problems. We provide a tailored solution for your situation: maintenance, repair or a virtual card to use on Back Market to replace your device.",
  },
}
